/**
 * Created by renjie.huang on 2018/1/4.
 */

var route = {
    path : '/oauth',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/OAuth.jsx').default)
        }, 'oauth')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/oauth.js